import InstitutionsSettleIn from "./-institutions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/review/institutions")({
  staticData: {
    menuLabel: "机构入驻",
    showInMenu: true,
    menuGroup: "/review",
    menuOrder: 2,
  },
  component: InstitutionsSettleIn,
});
